<template>
  <vue-input :placeholder="placeholder" @input="handleInput" :btn-class="btnClass" :input-class="inputClass" :value="selected"/>
</template>

<script>
import { debounce } from 'lodash';
import filter from '../../mixins/filter';

export default {
  mixins: [filter],

  props: {
    placeholder: {
      type: String,
      default: 'Rechercher',
    },

    btnClass: {
      type: String,
      default: null,
    },

    inputClass: {
      type: String,
      default: null,
    },
  },

  methods: {
    setSelected() {
      this.selected = this.getParam();
    },

    handleInput: debounce(function (value) {
      this.selected = value;
      return value
        ? this.updateUrlParam(value).broadcast()
        : this.removeUrlParam().broadcast();
    }, 500),
  },
};
</script>
